import {createFileRoute, redirect} from '@tanstack/react-router';

import PatientAuditLog from '@/patient/views/user/AuditLog';
import PractitionerAuditLog from '@/practitioner/views/user/AuditLog';
import {useIsPatient} from '@/shared/contexts/UserContext/useUserContext';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

function AuditLogWrapper() {
  const isPatient = useIsPatient();
  return isPatient ? <PatientAuditLog /> : <PractitionerAuditLog />;
}

export const Route = createFileRoute('/(shared)/audit-log')({
  component: AuditLogWrapper,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
